import { inject, Injectable, signal } from '@angular/core';
import { ShamDashboardSquare01BulkIcon } from 'sham-components/icons';
import { ShamSiteIdentity } from 'sham-components/services';

export interface ShamDashboardNavLink {
  name: string;
  paths: string;
  icon: object;
  items?: undefined;
}
export interface ShamDashboardNavGroup {
  name: string;
  items: ShamDashboardNavLink[];
}

/**
 * Inject to dashboard route with `useValue` and `provideAppInitializer` factory pattern.
 */
@Injectable({
  providedIn: 'root',
})
export class ShamDashboardData {
  public readonly siteIdentity = inject(ShamSiteIdentity);

  public readonly navPanelExpanded = signal(true);

  public readonly navLinks = signal<
    (ShamDashboardNavLink | ShamDashboardNavGroup | 'hr')[]
  >([
    {
      name: 'Dashboard',
      paths: '',
      icon: ShamDashboardSquare01BulkIcon,
    },
  ]);
}
